//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BlueLinks from "@/components/objects/public/shared-blocks/links/objects/design-variant/Blue.vue";
import SquareLinks from "@/components/objects/public/shared-blocks/links/objects/design-variant/Square.vue";
import Square2Links from "@/components/objects/public/shared-blocks/links/objects/design-variant/Square-2.vue";
import MinimalismLinks from "@/components/objects/public/shared-blocks/links/objects/design-variant/Minimalism.vue";
import { DesignExtra } from "@/utils/dto/objects.js";
import { getDefaultThemeSettings } from "@/constants/ui.js";
import isEmpty from "lodash/isEmpty.js";

export default {
  name: "LinksObjects",
  provide: {
    source: 'objConnections',
    module: 'links_objects',
  },
  props: {
    list: {
      type: Object,
      default: () => ({})
    },
    objectLabel: {
      type: String,
      default: () => ''
    },
    user: {
      type: Object,
      default: () => {}
    },
    designExtra: {
      type: Object,
      default: () => {}
    },
    useStorage: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const safeLinks = this.list || {};
    const design = safeLinks.design || 'square';
    const ui = safeLinks.ui_data || {};
    const defaultTheme = getDefaultThemeSettings(design, 'links_objects', this.$store)?.themes?.[0];
    return {
      currentDesign: design,
      currentTheme: ui.design_theme || defaultTheme?.theme,
      currentDesignExtra: isEmpty(safeLinks.design_extra) ? new DesignExtra(defaultTheme) : safeLinks.design_extra,
      currentTemplate: null,
      pageSize: 12,
      allItems: [],
      visibleCount: 12,
    }
  },
  computed: {
    prepopulatedItems() {
      const visible = this.allItems.slice(0, this.visibleCount)
      if (this.visibleCount < this.allItems.length) {
        return [...visible, { id: `load-next-${this.visibleCount}`, loader: true }]
      }
      return visible
    },
    renderComponent() {
      switch (this.currentDesign) {
      case "blue":
        return BlueLinks
      case "square-2":
        return Square2Links
      case "links_objects_default":
        return MinimalismLinks
      default:
        return SquareLinks
      }
    },
    listInfo() {
      return {
        label: this.list.label,
        subLabel: this.list.sublabel || "",
        icon: this.list.icon,
        vistat_object: this.list.vistat_object,
        object_label: this.objectLabel,
        id: this.list.id || this.list.uuid || '',
      }
    }
  },
  created() {
    const fromFull = Array.isArray(this.list.full_items_list) && this.list.full_items_list.length
      ? this.list.full_items_list
      : null
    this.allItems = [...(fromFull || this.list.items || [])]
  },
  mounted() {
    this.syncPageSizeToViewport()
    this.visibleCount = Math.min(this.pageSize, this.allItems.length)
    window.addEventListener('resize', this.syncPageSizeToViewport, { passive: true })
  },
  destroyed() {
    window.removeEventListener('resize', this.syncPageSizeToViewport)
  },
  methods: {
    syncPageSizeToViewport() {
      if (typeof window === 'undefined') return
      this.pageSize = window.innerWidth <= 640 ? 6 : 12
    },
    loadMoreChunk() {
      this.visibleCount = Math.min(
        this.visibleCount + this.pageSize,
        this.allItems.length
      )
    },
    onDesignChange(evt) {
      this.currentDesign = evt;
      const defaultTheme = getDefaultThemeSettings(evt, 'links_objects', this.$store)?.themes?.[0];
      this.currentDesignExtra = new DesignExtra(defaultTheme);
      this.currentTheme = defaultTheme?.theme;
    },
    onThemeChange(evt) {
      this.currentTheme = evt;
      const designSettings = getDefaultThemeSettings(this.currentDesign, 'links_objects', this.$store);
      const themeObj = designSettings?.themes?.find(el => el.theme === evt);
      this.currentDesignExtra = new DesignExtra(themeObj);
    },
  }
}
